export default __webpack_public_path__ + "static/Vol 3 - TA 8 - OCEMP (with appendices)-75859af8301e6ee1f06cd27516048aeb.pdf";